import { useCallback, useMemo } from 'react'
import {
  parseFullNumberToHalf,
  parseToHalfNumberOrEmptyString,
} from '../../utils/number'

export const useNumberParser = () => {
  const round = useCallback((v: number | undefined): number | undefined => {
    return typeof v === 'number' ? Math.round(v * 100) / 100 : undefined
  }, [])
  const parse = useCallback((v: string | undefined): number | undefined => {
    if (v === undefined || v === '') return undefined
    const halfStr = parseToHalfNumberOrEmptyString(v)
    const parsed = parseFloat(halfStr)
    if (isNaN(parsed) || parsed < 0) return undefined
    return parsed
  }, [])
  const parseFullToHalf = useCallback(
    (v: string | undefined): string | undefined => {
      if (v === undefined || v === '') return v
      return parseFullNumberToHalf(v)
    },
    []
  )

  const parser = useMemo(
    () => ({ round, parse, parseFullToHalf }),
    [round, parse, parseFullToHalf]
  )

  return parser
}
